import React from "react";

import { noop } from "lodash";

export const RuleBuilderContext = React.createContext({
	rules: [],
	setRules: noop,
	onRuleChange: noop,
	formVersion: 0,
	formElements: [],
	formSections: [],
	formType: "",
	formId: null,
	ruleOrderIndexes: null,
	setRuleOrderIndexes: noop,
	hasUnsavedOrderChanges: false,
	setHasUnsavedOrderChanges: noop,
	//TODO: Delete property
	ruleTypeHash: [],
	editingCondition: false,
	isDisclosureEnabled: false,
	setEditingCondition: noop,
	isEditingAction: false,
	setEditingAction: noop,
	isEditingOperand: false,
	setEditingOperand: noop,
	formChanged: false,
	setFormChanged: noop,
	newRuleOrder: null,
	setNewRuleOrder: noop,
});

export const RuleBuilderContextProvider = props => {
	const {
		children,
		rules,
		setRules,
		onRuleChange,
		formVersion,
		formElements,
		formSections,
		formType,
		formId,
		ruleOrderIndexes,
		setRuleOrderIndexes,
		hasUnsavedOrderChanges,
		setHasUnsavedOrderChanges,
		editingCondition,
		setEditingCondition,
		ruleTypeHash,
		isEditingAction,
		setEditingAction,
		isDisclosureEnabled,
		isEditingOperand,
		setEditingOperand,
		formChanged,
		setFormChanged,
		newRuleOrder,
		setNewRuleOrder,
	} = props;

	return (
		<RuleBuilderContext.Provider
			value={{
				rules,
				setRules,
				onRuleChange,
				formVersion,
				formElements,
				formSections,
				formType,
				formId,
				ruleOrderIndexes,
				setRuleOrderIndexes,
				hasUnsavedOrderChanges,
				setHasUnsavedOrderChanges,
				editingCondition,
				setEditingCondition,
				isDisclosureEnabled,
				ruleTypeHash,
				isEditingAction,
				setEditingAction,
				isEditingOperand,
				setEditingOperand,
				formChanged,
				setFormChanged,
				newRuleOrder,
				setNewRuleOrder,
			}}
		>
			{children}
		</RuleBuilderContext.Provider>
	);
};
